import React from 'react';
import {Map} from 'immutable';
import {buttonStyle} from './styles';
import {Plugins, withSystem, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {createRgbaColor} from '@packages/systems/core/utils/ColorUtils';
import {
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_BUTTON,
  QUICK_CHECKOUT_STATES,
} from '@packages/systems/commerce/constants';
import {SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS} from '@packages/systems/core/constants/SharedConstraintRules';
import {TListOfElement, TRecord, TText} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const styleDisplayNone = Map({style: Map({display: 'none'})});

const CommerceCartQuickCheckoutButton = Atom.createRender((props) => {
  const {attributes, classes, context, data, generateAttributes, renderChild} =
    props;

  const styledAttributes =
    context.get('previewState') !== QUICK_CHECKOUT_STATES.PAY_NOW
      ? attributes.merge(styleDisplayNone)
      : attributes;
  return (
    <a {...generateAttributes(styledAttributes, classes)}>
      {getChildren(data).map((child: EvaluatedNodeData) =>
        renderChild(child, context)
      )}
    </a>
  );
});

const config = createIntegratedAtom({
  displayName: 'Pay with browser',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Button')),
  },
  showEmpty: false,
  style: {
    base: {
      main: {
        noPseudo: {
          ...buttonStyle,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderTopLeftRadius: px(2),
          borderTopRightRadius: px(2),
          borderBottomRightRadius: px(2),
          borderBottomLeftRadius: px(2),
          marginBottom: px(8),
          height: px(38),
          backgroundColor: createRgbaColor('black'),
          paddingTop: px(0),
          paddingBottom: px(0),
        },
      },
    },
  },
  constraints: {
    ancestors: [{is: 'CommerceCartQuickCheckoutActions', rule: 'ExactlyOne'}],
    descendants: SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS,
  },
  render: CommerceCartQuickCheckoutButton,
  fields: {
    children: TListOfElement,
    attr: withSystem(
      {private: false},
      TRecord({
        role: withSystem({private: true, defaultValue: 'button'}, TText),
        tabindex: withSystem({private: true, defaultValue: '0'}, TText),
        'aria-haspopup': withSystem(
          {private: true, defaultValue: 'dialog'},
          TText
        ),
        [DATA_ATTR_NODE_TYPE]: withSystem(
          {
            private: true,
            defaultValue: NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_BUTTON,
          },
          TText
        ),
      })
    ),
  },
});

export default config;
